export default __webpack_public_path__ + "a15d05e3259275dd32ad3081a80b4307.png";